<template>
	<div>
		<div class="title">
			<div id="notice">
				<h5>考勤结果菜单说明:</h5><br>
				<span>1、最终生成的考勤结果,可以导出</span><br>
				<span>2、明细部分:汇总异常状态</span><br>
				<span class="red">3、考勤结果允许直接修改所有结果,但是如果重新审核考勤,会恢复原始计算值。</span><br>
				<span>4、查询关键字:月份,姓名。默认 查询当月</span><br>
			</div>
		</div>

		<pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">

			<!-- <template slot="slot_c_out_fee">
            <pre-select class="short0" ref="out_fee" @selectFunc="selectFunc1" v-bind:searchList="list_fee"
              :selectValue="sel_fee" />
          </template> -->

		</pre-base>
	</div>
</template>

<script>
	import api from '@/utils/type.js';

	import {
		Method_EasySelect
	} from '@/utils/loadhttpdata.js';

	import {
		daysFormMonth
	} from '@/utils/method.js';

	export default {
		components: {
			"pre-base": () => import("../auto/old_view_v1.vue")
		},
		data() {
			return {
				init_data: '',
				row_id: '',
				item: '',
				// 下拉菜单
				// list_fee: [],
				// sel_fee: {},
			};
		},
		mounted: function() {
			var that = this;
			this.$nextTick(function() {
				that.fun_init();
			});
		},
		methods: {
			fun_init: function() {

				let
					t_list_flag = [],
					t_list_user = [],
					t_list_type = [],
					t_list_department = [];

				// t_list_flag = await this.loadClass('data_flag');
				//  t_list_department = await this.loadClass('data_exp_item_class', '', '', 'dep');

				// t_list_user = await this.loadClass('data_alluser');

				// t_list_type = await this.loadClass('data_exp_rec_class', '1');

				this.init_data = '';
				this.init_data = JSON.stringify({
					"title": '考勤结果',
					"control": "recordend",
					"sel_action": 'exp_kq_rec_end',
					"upd_action": 'exp15_kq_rec_end_easy',
					"d_sel_action": 'exp_rec_end_d',
					"d_upd_action": 'rec_end_d',
					"isTwo": "0",
					"step": "1",
					"stop_title": "0",
					"isFatherSel": "1",
					"file_action": '',
					"p1": 'bdwl',
					"p2": '',
					"p3": '',
					"parm_sel": [{
							"name": "部门",
							"val": "",
							"key": "sheet_no",
							"type": "select",
							"class": "long1",
							// "list": t_list_department.data,
							"sel_action": "_base_dep",
							"sel_val": {},
							"sel_name": "",
							"sel": "1"
						},
						{
							"name": "姓名",
							"val": "",
							"key": "u_name",
							"type": "select",
							"class": "long1",
							// "list": t_list_user.data,
							"sel_action": "_base_salaryuser",
							"sel_val": {},
							"sel_name": "",
							"sel": "2"
						},
						{
							"name": "月份",
							"val": new Date(),
							"key": "month",
							"type": "month",
							"class": "long1",
							"sel": "3"
						},
						{
							"name": "状态",
							"val": "",
							"key": "flag",
							"type": "select",
							"class": "long1",
							"sel_action": "data_flag",
							"sel_val": {},
							"sel_name": "",
							"sel": "4"
						}
					],
					"parm": [{
							"name": "单号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1",
							"p": "1",
							"x": "1",
							"r": "1"
						},
						{
							"name": "开始日期",
							"val": "",
							"key": "s_date",
							"type": "text",
							"class": "long1",
							"x": "1",
							"r": "1"
						},
						{
							"name": "结束日期",
							"val": "",
							"key": "e_date",
							"type": "text",
							"class": "long1",
							"x": "1",
							"r": "1"
						},
						{
							"name": "姓名",
							"val": "",
							"key": "u2_name",
							"type": "text",
							"class": "long1",
							"x": "2",
							"r": "1"
						},
						{
							"name": "本月应出勤",
							"val": "",
							"key": "day_all",
							"type": "text",
							"class": "long1",
							"x": "2",
							"r": "1"
						},
						{
							"name": "实际出勤",
							"val": "",
							"key": "day_ok",
							"type": "number",
							"class": "long1",
							"p": "1",
							"x": "2",
							"r": "0"
						},
						{
							"name": "缺勤",
							"val": "",
							"key": "day_no",
							"type": "text",
							"class": "long1",
							"x": "2",
							"r": "1"
						},
						{
							"name": "缺打卡次数",
							"val": "",
							"key": "r_no",
							"type": "number",
							"class": "long1",
							"p": "1",
							"x": "3"
						},
						{
							"name": "缺日志次数",
							"val": "",
							"key": "w_no",
							"type": "number",
							"class": "long1",
							"p": "1",
							"x": "3"
						},
						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "text",
							"class": "long3",
							"p": "1",
							"x": "4"
						}
					],
					"parm_th": [{
							"name": "序号"
						},
						{
							"name": "单号"
						},
						{
							"name": "部门"
						},
						{
							"name": "姓名"
						},
						{
							"name": "开始日期"
						},
						{
							"name": "结束日期"
						},
						{
							"name": "状态"
						},
						{
							"name": "备注"
						},
						{
							"name": "录入人"
						},
						{
							"name": "更新时间"
						}
					],
					"d_parm": [{
							"name": "单号",
							"val": "",
							"key": "sheet_no",
							"type": "none",
							"class": "long1",
							"p": "1"
						},
						{
							"name": "出勤日期",
							"val": "",
							"key": "work_date",
							"type": "date",
							"class": "long1",
							"p": "1"
						},
						{
							"name": "类型",
							"val": "",
							"key": "rec_name",
							"type": "select",
							"class": "long1",
							"list": t_list_type.data,
							"sel_val": {},
							"sel_name": "",
							"p": "1"
						},
						{
							"name": "打卡时间",
							"val": "",
							"key": "s_up_time",
							"type": "datetime",
							"class": "long1",
							"p": "1"
						},
						{
							"name": "迟到时间",
							"val": "",
							"key": "late_minu",
							"type": "number",
							"class": "long1",
							"p": "1"
						},
						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "text",
							"class": "long1",
							"p": "2"
						},
					],
					"d_name": [{
							"name": "ID"
						},
						{
							"name": "序号"
						},
						{
							"name": "单号"
						},
						{
							"name": "出勤日期"
						},
						{
							"name": "类型"
						},
						{
							"name": "应打卡时间"
						},
						{
							"name": "打卡时间"
						},
						{
							"name": "备注"
						},
						{
							"name": "分钟"
						},
						{
							"name": "录入人"
						},
						{
							"name": "更新时间"
						},
					]
				});

			},
			refresh_data: function(type) {
				var that = this;
				this.$nextTick(function() {
					that.$refs['mybase'].refresh_data(type);
				});
			},
			refresh_father: function(type, val, parm) {
				console.log('type=' + type + ' val=' + val);
				switch (type) {
					case 'father':
						// 弹出修改明细，修改主窗口信息
						// this.refresh_data();
						this.change_title(val);
						break;
					case 'change_title':
						this.change_title(val);
						break;
					default:
						// console.log('子组件刷新父组件传值=' + val);
						this.row_id = val;
						this.item = parm;
						break;
				}
			},
			change_title: function(back) {

				console.log('选择结果=', back);
				let str = back[2].val
				console.log('解析结果=' + str);
				let days = 0,
					month = 0;
				var d = new Date();
				days = daysFormMonth(str);
				month = Number(str.substring(5, 7));

				console.log('解析month=' + month);

				let new_title = [];

				let o = {};
				o.name = '序号';
				o.val = '';
				new_title.push(o);
				o = {};
				o.name = '单号';
				o.val = '';
				new_title.push(o);
				o = {};
				o.name = '部门';
				o.val = '';
				new_title.push(o);
				o = {};
				o.name = '姓名';
				o.val = '';
				new_title.push(o);
				o = {};
				o.name = '开始日期';
				o.val = '';
				new_title.push(o);
				o = {};
				o.name = '结束日期';
				o.val = '';
				new_title.push(o);
				o = {};
				o.name = '状态';
				o.val = '';
				new_title.push(o);

				for (let i = 0; i < days; i++) {
					o = {};
					o.name = month + '月' + (i + 1) + '号';
					o.val = '';
					new_title.push(o);
				}

				o = {};
				o.name = '应出勤天数';
				o.val = '';
				new_title.push(o);
				o = {};
				o.name = '出勤';
				o.val = '';
				new_title.push(o);
				o = {};
				o.name = '缺勤';
				o.val = '';
				new_title.push(o);
				o = {};
				o.name = '缺卡次数';
				o.val = '';
				new_title.push(o);
				o = {};
				o.name = '缺日志次数';
				o.val = '';
				new_title.push(o);
				o = {};
				o.name = '备注';
				o.val = '';
				new_title.push(o);
				o = {};
				o.name = '录入人';
				o.val = '';
				new_title.push(o);
				o = {};
				o.name = '更新时间';
				o.val = '';
				new_title.push(o);

				var that = this;
				this.$nextTick(function() {
					that.$refs['mybase'].fun_change_title('main', JSON.stringify(new_title));
				});

			},
			loadClass: function(action, p1, p2, p3) {
				let that = this;
				return new Promise((resolve, reject) => {
					// console.log(menuvalue);
					that.$post(
						api.http_method, Method_EasySelect(action, p1, p2, p3)
					).then(res => {
						res = JSON.parse(res);
						// console.log(res.data);
						resolve(res.data)
					});

				});
			},





		}
	};
</script>
<style>
</style>